import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
};

const loaderSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoader: (state, action) => {
        state.loader = action.payload;
    },
  },
});

export const { setLoader } = loaderSlice.actions;

export const getLoaderState = (state: any) => state.loader.loader;
export default loaderSlice.reducer;